import React from 'react';
import { bool, func, object } from 'prop-types';
import AuctionForm from './AuctionForm';
import { history } from 'data/Store';

const EditAuction = ({
  auction,
  auctionEdited,
  fetchAuction,
  fetchGarage,
  fetchingCurrentAuction,
  fetchingGarage,
  garage,
  onClearEditAuction,
  onSubmit,
  ...props
}) => {
  React.useEffect(() => {
    if (!auction && !fetchingCurrentAuction) fetchAuction();
  }, [auction, fetchingCurrentAuction, fetchAuction]); //eslint-disable-line

  React.useEffect(() => {
    if (!garage && auction && auction.GarageID && !fetchingGarage)
      fetchGarage(auction.GarageID);
  }, [auction, garage, fetchingGarage, fetchGarage]);

  // Reset state data when auction created
  React.useEffect(() => {
    if (auctionEdited) {
      onClearEditAuction();
      history.push({
        pathname: `/auctions/${props.params.id}`,
      });
    }
  }, [onClearEditAuction, auctionEdited]); //eslint-disable-line

  const handleSubmit = React.useCallback(
    ({ auctionData, folderData }) => {
      onSubmit({
        auctionData: {
          ...auctionData,
          ID: auction.ID,
        },
        folderData: {
          ...folderData,
          ID: auction.FolderID,
        },
      });
    },
    [auction, onSubmit]
  );

  const formattedAuction = React.useMemo(
    () =>
      auction
        ? {
            ...auction,
            FolderNumber: undefined,
            FolderTitle: undefined,
            Number: auction.FolderNumber,
            Title: auction.FolderTitle,
          }
        : null,
    [auction]
  );

  return auction ? (
    <AuctionForm
      auction={formattedAuction}
      garage={garage}
      onSubmit={handleSubmit}
      {...props}
    />
  ) : null;
};

EditAuction.propTypes = {
  auction: object,
  auctionEdited: bool,
  fetchAuction: func,
  fetchGarage: func,
  fetchingCurrentAuction: bool,
  fetchingGarage: bool,
  garage: object,
  onClearEditAuction: func,
  ...AuctionForm.propTypes,
};

export default EditAuction;
